import { AnimatePresence, motion } from 'framer-motion';
import { create } from 'zustand';

export const useToast = create((set, get) => ({
  toasts: [],
  push: (toast) => {
    const id = crypto.randomUUID();
    const t = { id, kind: 'info', duration: 2800, ...toast };
    set({ toasts: [...get().toasts, t] });
    setTimeout(() => {
      set({ toasts: get().toasts.filter((x) => x.id !== id) });
    }, t.duration);
  },
}));

export function ToastStack() {
  const toasts = useToast((s) => s.toasts);
  return (
    <div className="toast-stack" aria-live="polite">
      <AnimatePresence>
        {toasts.map((t) => (
          <motion.div
            key={t.id}
            className={`toast ${t.kind}`}
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            exit={{ opacity: 0, x: 30 }}
            transition={{ type: 'spring', stiffness: 320, damping: 28 }}
          >
            {t.message}
          </motion.div>
        ))}
      </AnimatePresence>
    </div>
  );
}
